import React from 'react';
import { TAG_ICON_OPTIONS } from './tag-icon-utils';
import styles from './IconPicker.module.css';

export interface IconPickerProps {
  value: string;
  onChange: (name: string) => void;
  id?: string;
}

export const IconPicker: React.FC<IconPickerProps> = ({ value, onChange, id }) => {
  return (
    <fieldset className={styles.root} id={id}>
      <legend className={styles.legend}>Icon</legend>
      <div className={styles.iconGrid}>
        {TAG_ICON_OPTIONS.map(({ name, Icon, label }) => {
          const selected = value === name;
          return (
            <button
              key={name}
              type="button"
              title={label}
              className={`${styles.iconButton} ${selected ? styles.iconButtonSelected : ''}`}
              aria-pressed={selected}
              onClick={() => onChange(selected ? '' : name)}>
              <Icon aria-hidden />
              <span className={styles.iconLabel}>{name}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
};
